import { kgToTonnes } from '@container-system/shared';

/** Anzeige immer in Tonnen (1 Nachkommastelle) - Speicherung bleibt kg (siehe `shared/constants`), keine Verwechslungsgefahr wie im Altsystem mehr, da hier die einzige Stelle ist, die umrechnet. */
export function formatWeight(kg: number): string {
  return `${kgToTonnes(kg).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} t`;
}

export function formatDateTime(iso: string): string {
  return new Date(iso).toLocaleString('de-DE', { dateStyle: 'short', timeStyle: 'short' });
}

export function formatDate(iso: string): string {
  return new Date(iso).toLocaleDateString('de-DE');
}

/**
 * Für reine "YYYY-MM-DD"-Werte (kein Zeitanteil) - `new Date("YYYY-MM-DD")`
 * parst als UTC-Mitternacht; in einer Zeitzone westlich von UTC würde die
 * anschließende Umwandlung in die lokale Anzeigezeit auf den VORTAG
 * zurückfallen. Baut das Datum stattdessen direkt aus den Zahlenwerten,
 * ganz ohne Zeitzonen-Umweg.
 */
export function formatDateOnly(ymd: string, options: Intl.DateTimeFormatOptions = {}): string {
  const [year, month, day] = ymd.split('-').map(Number);
  return new Date(year!, month! - 1, day!).toLocaleDateString('de-DE', options);
}

export function formatTime(iso: string): string {
  return new Date(iso).toLocaleTimeString('de-DE', { hour: '2-digit', minute: '2-digit' });
}
